<div class="fm-stories-page">

  <!-- Action Cards -->
  <div class="row align-items-stretch">
    <div class="col-md-6">
      <div class="fm-card fm-primary-card fm-card-pattern-round h-100">
        <div class="row">
          <div class="col-xxl-11">
            <div class="d-flex flex-column">
              <div class="fm-icon-cl fm-icon-white-cl">
                <img class="fm-svg" src="images/icons/fm-video.svg" alt="Record a Story" />
              </div>
              <h3 class="fm-head-24 fm-card-title fm-head-sty2">Record a Story</h3>
              <p>Capture your memories in your own voice and turn moments into stories that last forever for generations.</p>
              <a routerLink="/app/stories/record" class="fm-common-tbtn">
                Record Your Story <img class="fm-svg" src="images/icons/fm-arrow-ar.svg" alt="Right Arrow" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 mt-4 mt-md-0">
      <div class="fm-card fm-secondary-card fm-card-pattern-round h-100">
        <div class="row">
          <div class="col-xxl-11">
            <div class="d-flex flex-column">
              <div class="fm-icon-cl fm-icon-white-cl">
                <img class="fm-svg" src="images/icons/fm-sprompt.svg" alt="Schedule a Prompt" />
              </div>
              <h3 class="fm-head-24 fm-card-title fm-head-sty2">Schedule a Prompt</h3>
              <p>Ask thoughtful, meaningful questions to spark memories and invite your loved ones to share their personal stories, experiences, and moments with you.</p>
              <a routerLink="/app/schedule" class="fm-common-tbtn">
                Create a Prompt <img class="fm-svg" src="images/icons/fm-arrow-ar.svg" alt="Right Arrow" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Filter Section -->
  <div class="row mt-4">
    <div class="col-12 mt-2 mt-xl-3">
      <div class="fm-white-column">
        <div class="row gy-3 gx-3 gx-xl-4">
          <div class="col-12 col-sm">
            <div class="fm-searchbar pe-xl-2">
              <form (submit)="$event.preventDefault()">
                <div class="form-group">
                  <input class="form-control" type="text"
                         placeholder="Search stories by title, people, or keyword"
                         aria-label="Search"
                         [value]="searchQuery()"
                         (input)="onSearch($any($event.target).value)" />
                </div>
                <button class="fm-search-btn" type="submit">
                  <img src="images/icons/fm-search-icon.svg" class="fm-svg" alt="Search Icon" />
                </button>
              </form>
            </div>
          </div>
          <div class="col-sm-auto">
            <div class="row gy-3 gx-3 gx-xl-4">
              <div class="col">
                <select class="form-select fm-form-select">
                  <option selected>Filters</option>
                  <option value="my">My Stories</option>
                  <option value="family">Family Stories</option>
                  <option value="shared">Shared Stories</option>
                </select>
              </div>
              <div class="col-auto">
                <div class="fm-filter-btn-grp">
                  <button type="button" class="fm-filter-cl-btn fm-filter-grid-btn"
                          [class.fm-fb-active]="viewMode() === 'grid'"
                          (click)="setViewMode('grid')">
                    <img src="images/icons/fm-column.svg" class="fm-svg" alt="Grid View" />
                  </button>
                  <button type="button" class="fm-filter-cl-btn fm-filter-list-btn"
                          [class.fm-fb-active]="viewMode() === 'list'"
                          (click)="setViewMode('list')">
                    <img src="images/icons/fm-list.svg" class="fm-svg" alt="List View" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="fm-filter-tags fm-filter-tags-scroll mt-4" tabindex="0" aria-label="Story categories">
              @for (cat of filterCategories; track cat.value) {
                <button type="button" class="fm-filter-tag fm-filter-btn"
                        [class.fm-ft-active]="activeFilter() === cat.value"
                        (click)="setFilter(cat.value)">
                  {{ cat.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Stories Grid / List -->
  @if (filteredStories().length > 0) {
    <div class="row mt-2 g-3 fm-stories-grid align-items-stretch" [class.fm-list-view]="viewMode() === 'list'">
      @for (story of filteredStories(); track story.id) {
        <div [class]="viewMode() === 'grid'
          ? 'col-sm-6 col-lg-4 mt-4 fm-story-filter-item'
          : 'col-12 mt-3 fm-story-filter-item'">
          <div class="fm-stories-blog fm-match-height h-100">
            <div class="fm-stories-cover">
              <img class="fm-image" [src]="story.coverImage" [alt]="story.title"
                   onerror="this.src='images/stories/stories-post-1.png'" />
              <span class="fm-tag">{{ story.duration }}</span>
              <button type="button" class="fm-stories-pp">
                <img src="images/icons/fm-play.svg" alt="Play Icon" class="fm-svg" />
              </button>
            </div>
            <div class="fm-stories-content">
              <div class="fm-st-promt-tag">
                <span class="fm-st-ti">{{ story.categoryLabel }}</span>
                @if (story.isPrompt) {
                  <span class="fm-st-ti fm-green">
                    <img src="images/icons/fm-magic.svg" alt="Magic Icon" /> Prompt
                  </span>
                }
              </div>
              <h4 class="fm-head-20 fm-head-sty2">
                <a [routerLink]="['/app/stories', story.id]">{{ story.title }}</a>
              </h4>
              <div class="fm-user-profile">
                <div class="fm-userprofile">
                  <div class="fm-left">
                    <div class="fm-userprofile-image">
                      <img class="fm-profile" [src]="story.authorAvatar" [alt]="story.authorName"
                           onerror="this.src='images/stories/fm-st-user-01.png'" />
                    </div>
                    <span class="fm-profile-content">
                      <span class="fm-profilename">
                        <a [routerLink]="['/app/stories', story.id]">{{ story.authorName }}</a>
                      </span>
                      <span class="fm-dateinfo">{{ story.date }}</span>
                    </span>
                  </div>
                  <ul class="fm-activity fm-rp-info">
                    <li><span><img class="fm-svg" src="images/icons/fm-eye.svg" alt="Views" /> {{ story.views }}</span></li>
                    <li><span><img class="fm-svg" src="images/icons/fm-heart.svg" alt="Hearts" /> {{ story.hearts }}</span></li>
                  </ul>
                </div>
                <hr class="my-0" />
                <p class="fm-black-cl fm-icon-content mb-0 mt-1">
                  <img src="images/icons/fm-family-group.svg" class="fm-family-icon" alt="Family Icon" />
                  {{ story.familyGroup }}
                </p>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="fm-stories-empty-state">
      <div class="fm-white-column text-center mt-4">
        <h4 class="fm-head-24 fm-head-sty2">No data found</h4>
        <p class="mb-0">Try another filter to see available stories.</p>
      </div>
    </div>
  }

</div>
